exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/room-changes/room-modal/room-modal.component.scss
// module id = ../../../../../src/app/main/pages/room-changes/room-modal/room-modal.component.scss
// module chunks = main